// load notification from API then feed to notification component in user dashboard
import axios from "axios"

export default {
  namespaced: true,
  state: {
    notification: [],
    length: null
  },


  mutations: {
    //add notification gotten from API to central store
    SET_NOTIFICATION: (state, payload) => state.notification = payload,
    //add total number of new notification gotten from API to central store
    SET_NOTIFICATION_LENGTH: (state, payload) => state.length = payload

  },


  actions: {
    //define an action called fetch_notification that gets notification from API and load it into central store, do this only when the user is authenticated 
    async fetch_notification({ dispatch }) {
      const response = await axios.get("/notification");

      if (response.data) {
        dispatch("parse_notification", response.data.notification)
      }
    },

    //afterwords mutate the response in another action  called parse_notification to add  { divider: true, inset: true }, after each notification  and group notification with same date
    parse_notification({ commit }, notification, /* notification_length */) {
      //add new notification
      // console.log(notification);
      // console.log(notification_length);


      if (notification /* && notificationLength */) {
        //todo parse notification here
        commit("SET_NOTIFICATION", notification)
        // commit("SET_NOTIFICATION_LENGTH", notification_length)

      }
    }
  },
  getters: {
    //feed off notification from central store
    data: (state) => state.notification,
    //fine a way to manage notification
    count: (state) => state.notification.length
  }
}
